



















import Vue from "vue";

export default Vue.extend({
  name: "EmptyScreen",
  props: {
    icon: {
      type: String,
      required: false,
      default: "mdi-store-off",
    },
    text: {
      type: String,
      required: false,
      default: "common.empty",
    },
  },
});
